module.exports = __webpack_public_path__ + "static/img/icon_saishihuodong.648a0005.png";